export class Group {
  id: string;
  name: string;
  description: string;
  candidatesNumber: number;
  protected: boolean;

  constructor(group: Partial<Group> = {}) {
    this.id = group.id ?? '';
    this.name = group.name ?? '';
    this.description = group.description ?? '';
    this.candidatesNumber = group.candidatesNumber ?? 0;
    this.protected = group.protected ?? false;
  }
}
